import { Button } from "antd";
import React, { Component } from "react";
import CommonButton from "./CommonButton";
import LinkButton from "./LinkButton";

const ModalPopupComponent = ({
  title,
  content,
  button1,
  button2,
  onclick1,
  onclick2,
  className1,
  className2,
  secondContent
}) => {
  return (
    <div className="doctor-availability">
      <div className="availability-header-modal">
        {title}
      </div>
      <div className="book-app-modal">
        <div className="content-container">
        <div className={!secondContent?"content2":"content"}>{content}</div>
        {secondContent && <div className="content2 padding-for-content2">{secondContent}</div>}
        </div>       
        <div className="appointment-modal-btn-container">
          <CommonButton
            className={className1}
            onClick={onclick1}
            label={button1}
          />
          <LinkButton className={className2} onClick={onclick2} label={button2}/>
        </div>
      </div>
    </div>
  );
};
export default ModalPopupComponent;
